/* ========================================================================
 * FD:          FD
 * Child:       SITE
 * Version:     1.0
 * ======================================================================== 
 * Description:
 * Controls hiding/showing/pinning the left navigation on any page
 * ======================================================================== 
 * 12/21/2015: creation
 * 09/04/2018: Fix issues around setting/unsetting tooltips
*/

FD.SITE = (function ($, me) {
    'use strict';

    var child = me.SITE || {};

    /* ========================================================================
     *  private vars
     * ========================================================================
    */

    var LEFTNAV_ELEM = '[data-siteleftnav="true"]';
    var LEFTNAVICON_ELEM = '[data-sitepinicon="true"]';
    var FIXEDTOP_ELEM = '[data-sitefixedtop="true"]';
    var PAGECONTENT_ELEM = '[data-sitepagecontent="true"]';

    //  vars
    var isReady = true;
    var leftNav = '';
    var triggerIcon = $(LEFTNAVICON_ELEM);
    var fixedTopContainer = $(FIXEDTOP_ELEM);
    var pageContainer = $(PAGECONTENT_ELEM);

    var ICONSTATE = {
        menu: 'fa-arrow-circle-right ',
        tack: 'fa-thumb-tack fa-rotate-90',
        rotate: 'fa-rotate-90',
        pinned: 'fa-thumb-tack'
    };

    var CLICKSTATE = {
        out: 0,
        in: 1,
        pinned: 2,
        hover: 3
    };

    var pinstate = null;  // "", "in", "pinned"
    var clickstate = CLICKSTATE.out;

    /* ========================================================================
     *  Private Methods
     * ========================================================================
    */


    function setLeftNavControl() {
        leftNav = $(LEFTNAV_ELEM);
        if (leftNav.length === 0) {
            return;
        }

        if (leftNav.hasClass('in')) {
            pinstate = "in";
        } else if (leftNav.hasClass('pinned')) {
            pinstate = "pinned";
        }
        
        if (pinstate === 'in') {
            triggerIcon.find('i').addClass(ICONSTATE.menu);
            clickstate = CLICKSTATE.in;
            leftNav.addClass('cursor-clickable');
            leftNav.off('click.sidenav').on('click.sidenav', openLeftNav);
        } else if (pinstate === 'pinned') {
            triggerIcon.find('i').addClass(ICONSTATE.pinned);
            triggerIcon.off('click.sidenavicon').on('click.sidenavicon', clickSideNavIcon);
            clickstate = CLICKSTATE.pinned;
        } 
    }


    function openLeftNav() {
        $('.tooltip').tooltip('hide');
        if (isReady && clickstate === CLICKSTATE.in) {
            setHover();
            return;
        }

        isReady = true;
    }


    function clickSideNavIcon(elem) {
        elem.stopPropagation();
        $('.tooltip').tooltip('hide');

        if (isReady) {
            isReady = false;
            if (clickstate === CLICKSTATE.pinned) {
                setUnPin();
            } else if (clickstate === CLICKSTATE.hover) {
                setPin();
            }

            // Fake a resize event so that highcharts/fixed table headers will readjust
            if ($('[data-fixedheader]').length > 0 || $('.highcharts-container').length > 0) {
                var resizeEvent = window.document.createEvent('UIEvents');
                resizeEvent.initUIEvent('resize', true, false, window, 0);
                window.dispatchEvent(resizeEvent);
            }
        } else {
            isReady = true;
        }
    }


    //  set unpin -- left nav collapsed
    function setUnPin() {
        triggerIcon.find('i').removeClass(ICONSTATE.pinned).addClass(ICONSTATE.menu);
        leftNav.addClass('in cursor-clickable').removeClass('pinned');
        leftNav.off('click.sidenav').on('click.sidenav', openLeftNav);
        if (leftNav.hasClass('wide-nav')) {
            pageContainer.removeClass('pinned-wide').addClass('in');
            fixedTopContainer.removeClass('pinned-wide').addClass('in');
        } else {
            pageContainer.removeClass('pinned').addClass('in');
            fixedTopContainer.removeClass('pinned').addClass('in');
        }
        clickstate = CLICKSTATE.in;
        triggerIcon.off('click.sidenavicon');
        isReady = true;
        
        me.PAGE.getAfterPinStateChangeEvent();

        setPinStateDB();
    }


    //  set hover -- left nav open but not pinned
    function setHover() {
        triggerIcon.find('i').removeClass(ICONSTATE.menu).addClass(ICONSTATE.tack);
        leftNav.addClass('pinned').removeClass('in cursor-clickable');
        leftNav.off('click.sidenav');
        triggerIcon.off('click.sidenavicon').on('click.sidenavicon', clickSideNavIcon);
        clickstate = CLICKSTATE.hover;
        isReady = true;

        $(document).off('click.hoverleft').on('click.hoverleft', function (event) {
            if (!ignoreHideNavEvent($(event.target))) {
                triggerIcon.find('i').removeClass(ICONSTATE.pinned).addClass(ICONSTATE.tack);
                leftNav.addClass('in cursor-clickable').removeClass('pinned');
                leftNav.off('click.sidenav').on('click.sidenav', openLeftNav);
                triggerIcon.find('i').removeClass(ICONSTATE.tack).addClass(ICONSTATE.menu);
                triggerIcon.off('click.sidenavicon');
                if (leftNav.hasClass('wide-nav')) {
                    pageContainer.removeClass('pinned-wide').addClass('in');
                    fixedTopContainer.removeClass('pinned-wide').addClass('in');
                } else {
                    pageContainer.removeClass('pinned').addClass('in');
                    fixedTopContainer.removeClass('pinned').addClass('in');
                }
                clickstate = CLICKSTATE.in;
                isReady = true;
            }
        });
    }


    // Check to see if we should ignore an event that might normally hide the left nav
    function ignoreHideNavEvent(target) {
        return target.parents(LEFTNAV_ELEM).length > 0
            || target.attr('data-siteleftnav') === 'true'
            || target.hasClass('ui-icon') // Added to prevent left nav from closing when using a datepicker element inside of it
            || target.hasClass('ui-datepicker-prev')
            || target.hasClass('ui-datepicker-next');
    }


    //  set pin -- left nav pinned to page
    function setPin() {
        triggerIcon.find('i').removeClass(ICONSTATE.tack).addClass(ICONSTATE.pinned);
        leftNav.addClass('pinned').removeClass('in cursor-clickable').off('click.sidenav');
        if (leftNav.hasClass('wide-nav')) {
            pageContainer.removeClass('in').addClass('pinned-wide');
            fixedTopContainer.removeClass('in').addClass('pinned-wide');
        } else {
            pageContainer.removeClass('in').addClass('pinned');
            fixedTopContainer.removeClass('in').addClass('pinned');
        }
        clickstate = CLICKSTATE.pinned;
        isReady = true;

        $(document).off('click.hoverleft');

        //  once left nav is open, only pin icon should be active
        triggerIcon.off('click.sidenavicon').on('click.sidenavicon', clickSideNavIcon);
        
        me.PAGE.getAfterPinStateChangeEvent();

        setPinStateDB();
    }


    //  set pin state in DB
    function setPinStateDB() {
        var options = {
            url: "/Common/Common/HandleUserApplicationNavPinStateCRUD",
            params: {
                applicationCode: me.getApplicationCode(),
                navIsPinned: clickstate === 2
            }
        };

        me.AJAX.setAJAX(options);
    }



    /* ========================================================================
     *  public methods
     * ========================================================================
    */

    //  set left navigation
    child.setLeftNavControl = function () {
        setLeftNavControl();
    };


    //  close left nav
    //  closes if user has hover out and a link is clicked
    child.LeftNavClose = function () {
        if (clickstate === CLICKSTATE.hover) {
            triggerIcon.find('i').removeClass(ICONSTATE.pinned).addClass(ICONSTATE.tack);
            leftNav.addClass('in cursor-clickable').removeClass('pinned');
            leftNav.off('click.sidenav').on('click.sidenav', openLeftNav);
            triggerIcon.find('i').removeClass(ICONSTATE.tack).addClass(ICONSTATE.menu);
            triggerIcon.off('click.sidenavicon');
            if (leftNav.hasClass('wide-nav')) {
                pageContainer.removeClass('pinned-wide').addClass('in');
                fixedTopContainer.removeClass('pinned-wide').addClass('in');
            } else {
                pageContainer.removeClass('pinned').addClass('in');
                fixedTopContainer.removeClass('pinned').addClass('in');
            }
            clickstate = CLICKSTATE.in;
            isReady = true;
        }
    };


    /* ========================================================================
     *  return
     * ========================================================================
    */
    return child;
}(jQuery, FD));